import React, { useEffect, useRef } from "react";
import { STATUS_CONFIG } from "./zahlungsplanUtils";

// Alle gültigen Status pro Typ (wie im Detail-Popover). Bewusst keine
// Vorwärts-Transitions-Map mehr: Einträge aus anderen Erfassungswegen tragen
// teils fremde Status (z.B. Ausgabe mit "expected"), bei denen sonst gar kein
// Menü erschien; das Popover erlaubt ohnehin jeden Statuswechsel.
const INCOME_STATUSES = ["expected", "sent", "paid", "overdue"];
const EXPENSE_STATUSES = ["expecting", "received", "entered_payment", "paid", "overdue"];

const ZahlungsplanContextMenu = ({ entry, position, onStatusChange, onAssignBeleg, onEdit, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!entry) return null;

  const currentStatus = entry.status || (entry.typ === "Einnahme" ? "expected" : "expecting");
  const transitions = (
    entry.typ === "Einnahme" ? INCOME_STATUSES : EXPENSE_STATUSES
  ).filter((s) => s !== currentStatus);

  return (
    <div
      className="zp-context-menu"
      ref={menuRef}
      style={{
        position: "fixed",
        left: position.x,
        top: position.y,
      }}
    >
      {/* Betrag bearbeiten (Direktklick auf gefüllte Zellen ist bewusst deaktiviert) */}
      {onEdit && (
        <>
          <button
            className="zp-context-menu-item"
            onClick={() => {
              onEdit(entry);
              onClose();
            }}
          >
            Bearbeiten
          </button>
          <div className="zp-context-menu-divider" />
        </>
      )}
      <div className="zp-context-menu-header">
        Status: {STATUS_CONFIG[currentStatus]?.label || currentStatus}
      </div>
      {transitions.map((status) => (
        <button
          key={status}
          className="zp-context-menu-item"
          onClick={() => {
            onStatusChange(entry, status);
            onClose();
          }}
        >
          <span
            className="zp-status-dot"
            style={{ backgroundColor: STATUS_CONFIG[status]?.color }}
          />
          {STATUS_CONFIG[status]?.label || status}
        </button>
      ))}
      {/* Beleg nachträglich zuordnen — auch bei bereits erhaltenen/bezahlten
          Ausgaben, solange noch kein Beleg verknüpft ist (ohne Statuswechsel). */}
      {entry.typ === "Ausgabe" && !entry.beleg_id && onAssignBeleg && (
        <>
          <div className="zp-context-menu-divider" />
          <button
            className="zp-context-menu-item"
            onClick={() => {
              onAssignBeleg(entry);
              onClose();
            }}
          >
            Beleg zuordnen…
          </button>
        </>
      )}
    </div>
  );
};

export default ZahlungsplanContextMenu;
